<template>
  <BizFiveXCreditsBanner
    :base-u-r-l="baseURL"
    :http="psHttp"
    :locale="locale"
    :enabled="isBannerEnabled"
    @click="handleBannerClick"
  />
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import psHttp from '@patsnap/common-ps-http';
import { controlDeferred } from '@eureka/utils/control';
import { clientDeferred } from '@eureka/utils/client';
import { isUserLogin } from '@eureka/utils/account';
import { FiveXCreditsBanner as BizFiveXCreditsBanner } from '@patsnap-biz/five-x-credits-banner';
import '@patsnap-biz/five-x-credits-banner/lib/style';

const { locale } = useI18n() as any;

const baseURL = import.meta.env.VITE_EUREKA_SERVICE_URI;
const isBannerEnabled = ref(false);

async function initBannerEnabled() {
  const [{ freemium }, { isFeiShu }, loggedIn] = await Promise.all([
    controlDeferred.promise,
    clientDeferred.promise,
    isUserLogin(),
  ]);
  isBannerEnabled.value = !!freemium && loggedIn && !isFeiShu;
}

onBeforeMount(async () => {
  await initBannerEnabled();
});

function handleBannerClick() {
  window.open(
    `${window.location.origin}/credits-price?price-range=five&trigger_source=five_x_credits_banner`,
    '_blank',
  );
}
</script>
